import { gql, useQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseQuery } from '@/lib/apollo/types'

const getActivityFeedForSubjectQuery = gql`
  query ($customerId: String!, $applicationId: String!, $subjectId: String!) {
    getActivityFeedForSubject(
      cusId: $customerId
      appId: $applicationId
      subId: $subjectId
    ) {
      desc
      timestamp
      message
      type
      createdBy
    }
  }
`

export type Activity = {
  desc: string
  timestamp: string
  message: string
  type: string
  createdBy: string
}

export type ActivityFeedForSubjectData = {
  getActivityFeedForSubject: Activity[]
}

type QueryVars = {
  customerId: string
  applicationId: string
  subjectId: string
}

export const useGetActivityFeedForSubjectQuery: WrappedUseQuery<
  ActivityFeedForSubjectData,
  QueryVars
> = options =>
  useQuery<ActivityFeedForSubjectData, QueryVars>(getActivityFeedForSubjectQuery, {
    ...options,
    client: agentClient,
  })
